module.exports = __webpack_public_path__ + "static/media/regret.3b13ec14.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/data/images/regret.jpg
 ** module id = 435
 ** module chunks = 0
 **/